import {
  Notification,
  NotificationsSummary,
  NotificationUpdatePayload,
  NotificationUpdateResponse,
} from "@contexts/Notifications/types";
import api from "@services/axios/originacao";

export const getNotificationsSummary =
  async (): Promise<NotificationsSummary> => {
    try {
      const { data } = await api.get<NotificationsSummary>(
        "/notificacoes/resumo/",
      );
      return data;
    } catch {
      throw new Error("Erro ao buscar resumo de notificações");
    }
  };

export const getNotifications = async (): Promise<Notification[]> => {
  try {
    const { data } = await api.get<Notification[]>("/notificacoes/");
    return data;
  } catch {
    throw new Error("Erro ao buscar notificações");
  }
};

export const updateNotification = async (
  notificationId: string,
  payload: NotificationUpdatePayload,
): Promise<NotificationUpdateResponse> => {
  try {
    const { data } = await api.patch<NotificationUpdateResponse>(
      `/notificacoes/${notificationId}/`,
      payload,
    );

    return data;
  } catch {
    throw new Error("Erro ao atualizar notificação");
  }
};
